module.exports = __webpack_public_path__ + "static/media/yafa_1.bed1f4b5.jpg";